import axios from "axios"; // tslint:disable-line match-default-export-name
import React from "react";

import { preloadImage } from "@use/preload-image";

import { LinkBlockModel } from "@courses-models/course";

import { getIcon } from "@apps/viewer/src/assets/icons";
import { config } from "@apps/viewer/src/ts/components/layout/Progressbar/Preview/config";
import { urls } from "@apps/viewer/src/ts/config";

import {
  Preview,
  PreviewProps,
  PreviewState,
  PreviewTitle,
} from "@apps/viewer/src/ts/components/layout/Progressbar/Preview/Preview";

/**
 * Specifies the minimum width of an image we're going to use as a thumbnail
 * for a link.
 */
const MINIMUM_THUMBNAIL_WIDTH = 265;

/**
 * Specifies the minimum height of an image we're going to use as a thumbnail
 * for a link.
 */
const MINIMUM_THUMBNAIL_HEIGHT = 149;

/**
 * Specification of the response from Gyldendal Gateway v3 site scraper, which
 * we're going to use to extract preview of links.
 */
type ScraperResponse = {
  images: string[];
};

/**
 * Renders a preview of link blocks consisting of title and link address.
 */
export class LinkPreview extends Preview<PreviewProps<LinkBlockModel>> {
  /**
   * Setup initial state
   */
  public state: PreviewState = {
    isActive: false,
  };

  /**
   * Renderer that'll inject the fallback icon, which is going to be used if
   * no thumbnail could be found for this block.
   */
  protected renderThumbnailFallbackIcon(): React.JSX.Element {
    return (
      <i>
        {getIcon("link2", { strokeColor: config.thumbnailIconColor })}

        <style jsx>{`
          /** Position the icon */
          i {
            /** Position at the bottom-left corner */
            position: absolute;
            top: 4px;
            right: -42px;

            /** Set up sizing */
            width: 248px;
            height: 259px;
          }
        `}</style>
      </i>
    );
  }

  /**
   * There are no SubTitles available for YouTube previews, simply return
   * title.
   */
  protected getTitle(): PreviewTitle {
    return {
      title: this.props.model.title,
    };
  }

  /**
   * For links we can safely use the href as the key, which our preview
   * depends upon.
   */
  protected getDataKey(): string | undefined {
    // Determine if protocol was already added
    return this.props.model.href.indexOf("//") !== -1
      ? this.props.model.href
      : `https://${this.props.model.href}`;
  }

  /**
   * MOCK - We need to implement a fetchContent, but there's really no other data
   * needed in order to render the preview for this block...
   */
  protected async fetchContent(): Promise<void> {
    return;
  }

  /**
   * Helper that'll return a url to a thumbnail associated with the url that
   * we're linking to.
   */
  protected async getThumbnailUrl(
    src: string | undefined,
  ): Promise<string | undefined> {
    return undefined;
  }
}
